import { CTA_TYPE, pushOmniEvents } from "./utils";

export const getCtaProperty = (
  name: string,
  type: CTA_TYPE,
  componentName: string,
  destination: string
) => {
  const cta = {
    name: name,
    type: type,
    componentName: componentName,
    destination: destination,
  };

  return cta;
};

export const pushCtaOmniEvents = (
  name: string,
  type: CTA_TYPE,
  componentName: string,
  destination: string
) => {
  const eventDetails = {
    cta: getCtaProperty(name, type, componentName, destination),
  };
  pushOmniEvents({ eventName: "ctaClick", details: eventDetails });
};